export const classes = {
  paper:
    'fixed top-8 self-start w-[452px] max-w-[calc(100vw-24px)] overflow-hidden rounded-[26px] border border-solid border-white/[0.78] bg-none bg-white/[0.68] backdrop-blur-[40px] backdrop-saturate-[1.3] shadow-[0_36px_90px_-28px_rgba(70,60,90,0.34),0_2px_12px_rgba(70,60,90,0.08)] dark:border-white/[0.14] dark:bg-[#242032]/[0.62] dark:shadow-[0_40px_100px_-30px_rgba(0,0,0,0.66),0_2px_12px_rgba(0,0,0,0.4)]',
  header: 'flex items-center gap-3 px-[22px] pt-[18px] pb-[14px]',
  badge:
    'size-[34px] shrink-0 place-center rounded-[11px] bg-grad text-white shadow-[0_8px_16px_-6px_rgba(241,90,43,0.42)] dark:bg-grad-dark dark:shadow-[0_8px_16px_-6px_rgba(0,0,0,0.5)]',
  titles: 'flex flex-col min-w-0',
  title:
    'text-[15px] font-bold tracking-[-0.01em] text-taupe-3 dark:text-mauve-1',
  subtitle: 'mt-0.5 text-xs font-normal text-taupe-1 dark:text-mauve-3',
  divider: 'mx-[14px] h-px bg-black/10 dark:bg-white/10',
  list: 'flex flex-col gap-2 px-[10px] pt-[10px] pb-4',
  row: 'group/row w-full text-left flex items-center gap-5 px-3 py-[11px] rounded-[15px] bg-transparent cursor-pointer transition-colors hover:bg-white/[0.35] dark:hover:bg-white/[0.06]',
  keycap:
    'flex-none place-center w-12 h-10 rounded-xl font-mono text-base font-bold',
  prefix: 'opacity-50',
  label: 'flex-1 min-w-0 text-2xl font-normal text-taupe-2 dark:text-mauve-2',
  chevron:
    'shrink-0 text-[17px] text-taupe-1 dark:text-mauve-3 opacity-0 -translate-x-1 transition group-hover/row:opacity-100 group-hover/row:translate-x-0',
};

export const styles = {
  backdrop: {
    backgroundColor: 'rgba(22,18,28,0.3)',
    backdropFilter: 'blur(2px)',
  },
  keycap: (accent: string) => ({
    backgroundColor: `${accent}38`,
    color: accent,
  }),
};
